// Also imported by the server to validate dismissals, so keep it free of
// React and browser APIs. Copy lives in home:release.<key>.*
export interface Release {
  id: string
  key: string
  // YYYY-MM-DD, shown in the banner
  date: string
  cta?: "connection"
}

// newest first; only the newest is ever shown
export const RELEASES: Release[] = [
  {
    id: "2026-10-selective-sync",
    key: "selectiveSync",
    date: "2026-10-28",
    cta: "connection",
  },
]

export const MAX_RELEASE_ID_LENGTH = 64
export const RELEASE_MAX_AGE_DAYS = 30
export const RELEASE_MAX_DEVICE_VIEWS = 2
const DAY_MS = 24 * 60 * 60 * 1000

export interface ReleaseBannerFlags {
  hasConnections: boolean
  nextBannerVisible: boolean
  reauthWarningVisible: boolean
  // times this device has already shown the newest release
  deviceViews?: number
  now?: Date
}

export const releaseIsStale = (release: Release, now: Date): boolean =>
  now.getTime() - Date.parse(release.date) >= RELEASE_MAX_AGE_DAYS * DAY_MS

export const releaseToShow = (
  dismissedId: string | null | undefined,
  {
    hasConnections,
    nextBannerVisible,
    reauthWarningVisible,
    deviceViews = 0,
    now = new Date(),
  }: ReleaseBannerFlags,
  releases: Release[] = RELEASES
): Release | undefined => {
  if (!hasConnections || nextBannerVisible || reauthWarningVisible) return
  const newest = releases[0]
  if (!newest || newest.id === dismissedId) return
  if (releaseIsStale(newest, now) || deviceViews >= RELEASE_MAX_DEVICE_VIEWS)
    return
  return newest
}

export const isKnownReleaseId = (value: unknown): value is string =>
  typeof value === "string" &&
  value.length <= MAX_RELEASE_ID_LENGTH &&
  RELEASES.some(({ id }) => id === value)
